import {Radio, RadioProps} from "@mui/material"

import React from 'react'

const BlueRadio = (props: RadioProps) => {
  return (
    <Radio
    sx={{
        color: "var(--kyocera-blue)",
        "&.Mui-checked": {
          color: "var(--kyocera-blue)",
        },
    }}
    color="default"
    {...props}
    />
    
  )
}

export default BlueRadio

